import type { TicketStatus } from '../types';

/** Canonical lifecycle order. */
export const TICKET_STATUS_ORDER: TicketStatus[] = ['NEW', 'IN_PROGRESS', 'AWAITING_CUSTOMER', 'CLOSED'];

export function ticketStatusMeta(status: TicketStatus): { label: string; badgeClass: string } {
  switch (status) {
    case 'NEW': return { label: 'Nowy', badgeClass: 'badge badge-primary' };
    case 'IN_PROGRESS': return { label: 'W trakcie', badgeClass: 'badge badge-warning' };
    case 'AWAITING_CUSTOMER': return { label: 'Czeka na klienta', badgeClass: 'badge badge-employee' };
    case 'CLOSED': return { label: 'Zamknięte', badgeClass: 'badge badge-danger' };
    default: return { label: String(status), badgeClass: 'badge' };
  }
}

export const ticketStatusLabel = (s: TicketStatus) => ticketStatusMeta(s).label;
